import { ReducerBuilder } from './reducerBuilder';
import { AirportsState } from 'acscp/store/airportsState';
import {
    ChangeLocaleAutomatically,
    ChangeLocaleFromSharingLink,
    ChangeLocaleFromUserDetails,
    ChangeLocaleManually,
    ClearAirportsSearchResults,
    SearchAirportsComplete
} from 'acscp/actions';
import { DateTime } from 'acscp/store';
import { AirportsRequest } from 'acscp/api/requests';
import { AirportsList } from 'acscp/api/models/airportsList';

const emptyAirportsState = () => ({
    airports: {},
    searchResults: {},
    currentResults: []
});

export const airportsReducer = new ReducerBuilder<AirportsState>(emptyAirportsState())
    .successfulRequestCase(AirportsRequest, (state, response: AirportsList, request) => {
        const newAirports = {...state.airports};
        response.forEach(a => newAirports[a.id] = a);
        return {
            airports: newAirports,
            searchResults: {
                ...state.searchResults,
                [request.searchString]: {
                    airports: response.map(a => a.id),
                    lastUpdated: DateTime.Now()
                }
            },
            currentResults: state.currentResults
        };
    })
    .actionCase(SearchAirportsComplete, (state, action) => {
        return {
            ...state,
            currentResults: action.filteredResults
        };
    })
    .actionCase(ClearAirportsSearchResults, (state, action) => {
        return {
            ...state,
            currentResults: []
        };
    })
    .actionCase(ChangeLocaleFromUserDetails, (state, action) => emptyAirportsState())
    .actionCase(ChangeLocaleManually, (state, action) => emptyAirportsState())
    .actionCase(ChangeLocaleAutomatically, (state, action) => emptyAirportsState())
    .actionCase(ChangeLocaleFromSharingLink, (state, action) => emptyAirportsState())
    .build();
